import type { PartialNonNull } from "../../types";

/**
 * Type guard that narrows an object with a nullable `id` to one whose `id`
 * is guaranteed to be non-null. Rejects both `null` and `undefined`.
 */
export default function hasId<T extends { id: number | null | undefined }>(
  value: T,
): value is PartialNonNull<T, "id"> {
  return value.id != null;
}
